import { render, staticRenderFns } from "./WIP.vue?vue&type=template&id=2df27f0e&scoped=true&"
import script from "./WIP.vue?vue&type=script&lang=js&"
export * from "./WIP.vue?vue&type=script&lang=js&"
import style0 from "./WIP.vue?vue&type=style&index=0&id=2df27f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df27f0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
